import { useEffect } from "react";
import { COMPANY, SITE_URL } from "@/data";

const BASE = "VistaWash. Detailing Automobile Châtelet & Charleroi";
const DEFAULT_IMAGE = "https://customer-assets.emergentagent.com/job_site-gen-40/artifacts/w8qlhov1_CAB43020-D96D-4806-BF75-FFC804326E21.png";

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const upsertJsonLd = (id, obj) => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.id = id;
    el.type = "application/ld+json";
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
};

const SEO = ({ title, description, path = "/", image = DEFAULT_IMAGE, noindex = false }) => {
  useEffect(() => {
    const fullTitle = title ? `${title} | VistaWash` : BASE;
    document.title = fullTitle;
    const url = `${SITE_URL}${path}`;

    upsertMeta("name", "description", description);
    upsertMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");
    upsertLink("canonical", url);

    // Open Graph
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "VistaWash");
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", image);
    upsertMeta("property", "og:locale", "fr_BE");

    // Twitter
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);

    // LocalBusiness JSON-LD (only injected once, on home)
    if (path === "/") {
      upsertJsonLd("ld-local-business", {
        "@context": "https://schema.org",
        "@type": "AutoDetailing",
        name: "VistaWash",
        image,
        "@id": SITE_URL,
        url: SITE_URL,
        telephone: COMPANY.phone_display,
        email: COMPANY.email,
        priceRange: "€€€",
        address: {
          "@type": "PostalAddress",
          streetAddress: COMPANY.address_line1,
          postalCode: "6200",
          addressLocality: "Châtelet",
          addressRegion: "Hainaut",
          addressCountry: "BE",
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: 50.4051,
          longitude: 4.5256,
        },
        openingHoursSpecification: [
          {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            opens: "09:00",
            closes: "18:00",
          },
        ],
        sameAs: [
          "https://www.google.com/maps/place/VistaWash",
        ],
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5.0",
          reviewCount: "35",
          bestRating: "5",
        },
        areaServed: [
          { "@type": "City", name: "Châtelet" },
          { "@type": "City", name: "Charleroi" },
          { "@type": "City", name: "Namur" },
          { "@type": "City", name: "Gerpinnes" },
          { "@type": "City", name: "Fleurus" },
        ],
        makesOffer: [
          { "@type": "Offer", name: "Nettoyage automobile premium", price: "79", priceCurrency: "EUR" },
          { "@type": "Offer", name: "Polissage automobile", price: "350", priceCurrency: "EUR" },
          { "@type": "Offer", name: "Traitement céramique", price: "490", priceCurrency: "EUR" },
        ],
      });
    }
  }, [title, description, path, image, noindex]);

  return null;
};

export default SEO;
